/**
 * Вопросы на главной странице
 */
// tslint:disable:max-line-length
export const QUESTIONS = [
  {
    title: 'Что такое Помощник по недвижимости?',
    body: 'Это набор статей, подготовленный специалистами ЦИАН, и разбитых на простые этапы, которые вам предстоит пройти в процессе самостоятельной продажи недвижимости.',
  },
  {
    title: 'Откуда вы берёте информацию?',
    body: 'За более чем 15 лет работы ЦИАН развил серьезную экспертизу в области недвижимости. Настало время поделиться этой информацией со всеми!',
  },
  {
    title: 'Для кого предназначен этот Помощник?',
    body: 'Для людей, кто решил продать недвижимость самостоятельно или только задумался о продаже. В Помощнике вы найдете информацию о каждом из этапов продажи, с нашими советами и предупреждениями о том, чего стоит ожидать.',
  },
  {
    title: 'Продавать самостоятельно или обратиться к риэлтору?',
    body: 'На этот вопрос у нас нет ответа. Самостоятельная продажа позволит вам существенно сэкономить (в среднем, услуги риэлтора обойдутся в 1-3% от стоимости продажи квартиры), но при этом вам нужно быть готовым к тому, что это долгий и сложный процесс. Настоятельно рекомендуем вам перед принятием решения ознакомиться со статьями Помощника.',
  },
  {
    title: 'Я не нашел ответа на свой вопрос. Что делать?',
    component: 'no-answer',
  },
];
// tslint:enable:max-line-length
